export default (obj) => (
  Object.entries(obj)
    // eslint-disable-next-line no-unused-vars
    .filter(([key, v]) => v != null)
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
);
